// extracted by mini-css-extract-plugin
export default {"wrapper":"WistiaPlayer_wrapper__wRkE2","imageWrapper":"WistiaPlayer_imageWrapper__9SpDF","playButton":"WistiaPlayer_playButton__1QudX"};